module.exports = __webpack_public_path__ + "assets/img/45130a2a1db2168d1582dc69eb9a4b17.webp";